module.exports = __webpack_public_path__ + "img/5-4.d396fc1a.svg";